"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WithReveal = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _fonts = require("./fonts");
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Reveal = (0, _styledComponents.default)(function (props) {
  var _props$label;
  var _useTranslation = (0, _reactI18next.useTranslation)('libTransfers'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement("div", props, /*#__PURE__*/_react.default.createElement(_fonts.P, null, (_props$label = props.label) !== null && _props$label !== void 0 ? _props$label : t('tapToReveal')));
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  z-index: 2;\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: ", ";\n  color: ", ";\n  border: 1px solid ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  width: 100%;\n  border-radius: ", ";\n  cursor: pointer;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.secondaryShade;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.tertiaryShade;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.secondaryShade2;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.radius.sm;
});
var WithReveal = (0, _styledComponents.default)(function (_ref5) {
  var className = _ref5.className,
    children = _ref5.children,
    _ref5$revealed = _ref5.revealed,
    revealed = _ref5$revealed === void 0 ? true : _ref5$revealed,
    disabled = _ref5.disabled,
    onReveal = _ref5.onReveal,
    label = _ref5.label;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, children, !revealed && /*#__PURE__*/_react.default.createElement(Reveal, {
    label: label,
    onClick: function onClick() {
      if (!disabled && onReveal) onReveal();
    }
  }));
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n"])));
exports.WithReveal = WithReveal;